import React, { ErrorInfo } from 'react';
import ErrorPage from './pages/ErrorPage';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      hasError: true,
      error,
      errorInfo
    });
    // You can also log the error to an error reporting service here
  }

  clearError = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
  })};

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage error={this.state.error} errorInfo={this.state.errorInfo} handleClick={this.clearError} />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;